// max number of pages which don't need dots
export const MAX_PAGES_WITHOUT_DOTS = 6;
export const PAGE_INDEX_OFFSET = 3;
// number of pages shown at beginning/end when currentPage is within first/last 3 pages
export const PAGES_AT_START_OR_END = 4;
